export default [
  {
    header: 'trombinoscope',
  },
  {
    title: 'Trombinoscope',
    icon: 'CameraIcon',
    route: 'trombinoscope',
  }
]